var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.5V15.8333C16.5 14.9493 16.1488 14.1014 15.5237 13.4763C14.8986 12.8512 14.0507 12.5 13.1667 12.5H7.33333C6.44928 12.5 5.60143 12.8512 4.97631 13.4763C4.35119 14.1014 4 14.9493 4 15.8333V17.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 9.16667C12.1743 9.16667 13.6667 7.67428 13.6667 5.83333C13.6667 3.99238 12.1743 2.5 10.3333 2.5C8.49238 2.5 7 3.99238 7 5.83333C7 7.67428 8.49238 9.16667 10.3333 9.16667Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.785 15.2625C10.1133 15.0875 10.2775 15 10.4583 15C10.6392 15 10.8033 15.0875 11.1317 15.2625L11.2433 15.3225C11.5717 15.4975 11.7358 15.585 11.8267 15.7292C11.9167 15.8733 11.9167 16.0483 11.9167 16.3992V16.5175C11.9167 16.8675 11.9167 17.0425 11.8267 17.1875C11.7358 17.3317 11.5717 17.4192 11.2433 17.5942L11.1317 17.6542C10.8033 17.8292 10.6392 17.9167 10.4583 17.9167C10.2775 17.9167 10.1133 17.8292 9.785 17.6542L9.67333 17.5942C9.345 17.4192 9.18083 17.3317 9.09 17.1875C9 17.0433 9 16.8683 9 16.5175V16.3992C9 16.0492 9 15.8742 9.09 15.7292C9.18083 15.585 9.345 15.4975 9.67333 15.3225L9.785 15.2625Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAccount);
export default __webpack_public_path__ + "static/media/menu_account.a9eecb0d435fd3da908310bab0c6edc4.svg";
export { ForwardRef as ReactComponent };